import React, { useState } from 'react';
import { Layout, Card } from 'antd';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import SearchUserForm from "./searchUserForm";
import SearchUserserTable from "./searchUserTable";

import '../user.css';

const {Content} = Layout;

function SearchUser() {
    const [data, setData] = useState([]);
    const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE)

    function search(payload) {
        setData(payload);
    }

    const handleChangeSize = (pageSize) => {
		setPageSize(pageSize)
	}

    return (
        <div>
            <Card>
            <PageTitle pageTitle="USER MAINTENANCE" />
            <Content>
                <SearchUserForm onFinish={ search }  />
                    <SearchPager 
                        pageTotal={data.length === null ? 0 : data.length}
                        pageSize={pageSize}
                        handleChangeSize={handleChangeSize}
                    />
                <SearchUserserTable data={data} pageSize={pageSize} />
            </Content>
            </Card>
        </div>
    );
}

export default SearchUser;